import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'andLast'
})
export class AndLastPipe implements PipeTransform {


  transform(stringArray: string[]): string {
    if (!stringArray || !stringArray.length) {
      return '';
    } else {
      if (typeof stringArray === 'string') {
        return stringArray;
      } else if (typeof stringArray === 'object' && stringArray.length) {

        if (stringArray.length <= 1) {
          return stringArray[0];
        } else {
          const earlierItems = stringArray.slice(0, stringArray.length - 1);
          const lastItem = stringArray.slice(-1).pop();
          const earlierString = earlierItems.join(', ');
          return earlierString + ' and ' + lastItem;
        }
      } else {
        return '';
      }
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/shared/pipes/and-last.pipe.ts